<template>
    <div class="container-top" ref="ledLabel" :style="style">
        <div class="container"   >
            <table class="table" style="width: 100%;color:white; font-size: 0.8em;">
                <tr><th scope="col" colspan="4" style="text-align:center;font-size:15px;">{{ title }}主机设置</th></tr>
                <tr><td >路段：</td><td >{{ hostRoad }}</td><td  >工作模式：</td><td >{{hostMode}}</td></tr>
                <tr><td >经度：</td><td >{{ hostLon }}</td> <td  >纬度：</td><td >{{hostLat}}</td></tr>
                <tr><td >温度：</td><td >{{ hostTemp }}</td><td  >湿度：</td><td >{{hostDam}}</td></tr>
                <tr><td >照度：</td><td >{{ hostLight }}</td><td >能见度：</td><td >{{hostVis}}</td></tr>
            </table>        
        </div>
        <div class="popup-tip-container">
            <div class="popup-tip  popup-background"></div>
        </div>
    </div>
</template>

<script>

export default {
    name:'DisplayLabelOnLED',
    data(){
        return {
            scene:'',
            style:{width:'460px' ,height:'130px'},
            title:'60050010',
            hostRoad:'',
            hostMode:'',
            hostLon:'',
            hostLat:'',
            hostTemp:'',
            hostDam:'',
            hostLight:'',
            hostVis:'',
        }
    },
    methods:{
        getLedHostData(ledHost){
            console.log('getLedHostData = ',ledHost[0],ledHost[1]);
            this.title = ledHost[0].gprsAddr ;
            this.hostRoad = ledHost[0].road + " " + ledHost[0].name;
            var workmode = ["手动模式","时区模式","轮廓加强","主动诱导","防碰撞","自动模式","偶黄奇红","偶红奇黄","全红模式","测试模式",]
            this.hostMode = workmode[ledHost[0].mode] ;
            this.hostLon = ledHost[0].lon.toFixed(6);
            this.hostLat = ledHost[0].lat.toFixed(6);
            this.hostTemp = ledHost[0].temp==null?0: ledHost[0].temp.toFixed(6);
            this.hostDam = ledHost[0].dampness.toFixed(0) || [];
            this.hostLight = ledHost[0].brightness;
            this.hostVis = ledHost[0].nengjiandu;

            // let position = Cesium.Cartographic.fromDegrees(lon, lat, height);
            let coord = bd09_to_wgs84(this.hostLon ,this.hostLat);
            let cartesian3 = Cesium.Cartesian3.fromDegrees(coord.longitude, coord.latitude,0);
            let cartesian2 = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene,cartesian3);
            // console.log('cartesian2 and cartesian3 = ',this.viewer.scene,cartesian2, cartesian3);
            this.style.left = cartesian2.x -325 +'px'; //325
            this.style.top = cartesian2.y - 220   + 'px';//- 220
            // console.log(' ref="ledLabel" = ',this.$refs.ledLabel.getBoundingClientRect().top);
        },
        getViewer(viewer){
            this.viewer = viewer;
        }
    },
    mounted(){
        this.$bus.on("ledHostDataOnLabel",this.getLedHostData);
        this.$bus.on('getViewer',this.getViewer);
    },
    beforeUnmount(){
        this.$bus.all.clear();
    }
}
</script>

<style scoped>
.container-top{
    position: absolute;
}
td:nth-child(1),:nth-child(3){
    width: 20%;
    text-align: center;
}
td:nth-child(2),:nth-child(4){
    width: 30%;
    text-align: left;
    /* white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; */
}
.container{
    position: absolute;
    width: 480px;
    height: 140px;
    background-color: rgba(0, 0, 0, .7);
    border-radius: 5px;
}
.table{
    padding-top: 5px;
    padding-right: 5px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.popup-tip-container {
    margin: 140px 230px;
    width: 40px;
    height: 13px;
    position: absolute;
    overflow: hidden; 
}
.popup-tip {
    box-shadow: 0 3px 14px rgba(0, 0, 0, .6);
    width: 17px;
    height: 17px;
    padding: 1px;
    margin: -10px auto 0;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}
.popup-background {
    background: rgba(0, 0, 0, .6);
    border-radius: 6px;
}
</style>